import styled from 'styled-components';

const BreadcrumbStyled = styled('ul')`
  padding: 0 6px;
  margin-top: 0;
  margin-bottom: 20px;
  & > li {
    display: inline;
    list-style: none;
    color: #002f3f;
    font-size: 14px;
    a {
      text-decoration: none;
      color: #06a1b5;
      font-size: 14px;
      &:hover {
        text-decoration: underline;
      }
    }
    & + li:before {
      content: '\\f3d1';
      color: #06a1b5;
      margin: 0 7.5px;
      font-family: ionicons;
      font-size: 13px;
    }
  }
`;

export default BreadcrumbStyled;
